import { Typography } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const EditableText = styled(Typography)`
  width: 100%;
  cursor: pointer;
  position: relative;

  &:hover {
    &::before {
      content: "";
      position: absolute;
      top: -0.25rem;
      left: -0.25rem;
      right: -0.25rem;
      bottom: -0.25rem;
      border: 1px solid ${(p) => p.theme.colors.primary};
      border-radius: 0.5rem;
      background: transparent;
    }
  }

  a {
    text-decoration: none;
  }
`;
